import { Suggestion } from './types'

/**
 * A simple cache for storing suggestions.
 */
export class AiSuggestionCache {
  private cache: Map<string, Suggestion[]> = new Map()

  public get(key: string): Suggestion[] | undefined {
    return this.cache.get(key)
  }

  public set(key: string, value: Suggestion[]): void {
    this.cache.set(key, value)
  }

  public clear(): void {
    this.cache.clear()
  }
}
